const ProblemSection = () => {
  const problems = [
    "You rely on a brokerage page you don't control",
    "Your site uses a generic template that looks like everyone else's",
    "It doesn't reflect the professionalism you bring to your work",
    "Visitors can't quickly understand what makes you different",
    "You hesitate to send prospects to it",
    "It undermines the credibility you've built in person",
  ];

  return (
    <section className="section-padding">
      <div className="container-narrow">
        <div className="max-w-[840px] mx-auto">
          <h2 data-reveal className="text-3xl md:text-4xl font-semibold text-center mb-6 text-primary">
            Most Real Estate Websites Undermine Trust
          </h2>
          
          <p data-reveal style={{ transitionDelay: "100ms" }} className="text-soft text-center text-lg mb-12">
            Your online presence is often the first impression — and for many agents, it's working against them.
          </p>

          <ul className="space-y-4">
            {problems.map((problem, index) => (
              <li 
                key={index}
                data-reveal
                style={{ transitionDelay: `${150 + index * 80}ms` }}
                className="flex items-start gap-4 p-4 bg-card rounded-lg border border-border/50"
              >
                <span className="flex-shrink-0 w-2 h-2 rounded-full bg-primary mt-2.5" />
                <span className="text-foreground text-lg">{problem}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
